import Vue from 'vue'
import http from './http'
import $ from 'jquery'
class InvokeRequest {
  interfaceId
  data
}

const inbound = {
  post (option = InvokeRequest) {
    let data = option.data || {}
    $.extend(data, {
      openid: localStorage.getItem('openid'),
      userId: localStorage.getItem('userId')
    })
    let requesturl = "";
    if(process.env.NODE_ENV !='development'){
		requesturl = "http://43.129.236.166:8081/"+option.interfaceId;  
		  // requesturl = "http://127.0.0.1:8081/"+option.interfaceId;
    }else{
		  // requesturl = "http://127.0.0.1:8081/"+option.interfaceId;
       requesturl = "http://43.129.236.166:8081/"+option.interfaceId;  
       // requesturl = "http://127.0.0.1:8081/"+option.interfaceId;
    }
    return new Promise((resolve, reject) => { 
      // const url = "http://localhost:8080/"+option.interfaceId;
      http.post(requesturl, {
        interfaceId: option.interfaceId,
        data: JSON.stringify(data)
      }).then(v => {
        if (v.MSGID == 'E') {
          reject(v)
        } else {
          resolve(v)
        }
      }).catch(e => {
        reject(e)
      })
    })
  },
}

export default {
  ...{
    install: function () {
      Vue.prototype.$inbound = inbound
    }
  }, ...inbound
}
